// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/Details/Details.css
// module id = 1637
// module chunks = 0